import { IconButtonProps } from '@mui/material';

import * as S from './IconButton.styled';

interface IProps extends IconButtonProps {
  children: React.ReactNode;
}

export const IconButton = ({ children, ...rest }: IProps) => (
  <S.IconButton {...rest}>{children}</S.IconButton>
);
